/* istanbul ignore file */
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchSubmissionDataParser = /* #__PURE__ */ parsers.object([
    [
        'grade',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecNumber)),
    ],
]);
export class PatchSubmissionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSubmissionDataParser.decode(input).map(res => new PatchSubmissionData(res));
    }
    static unsafeDecode(input) {
        return PatchSubmissionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSubmissionDataParser.encode(data);
    }
    static schema() {
        return PatchSubmissionDataParser.schema();
    }
}
